export function AboutPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            About AVUX
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            AVUX Consulting is the senior partner you are hiring.
          </h1>
          <p className="mt-4 text-slate-300">
            We specialize in mission-critical UX, AI, and operational transformation for government, community, and enterprise teams.
          </p>
        </header>
        <div className="mt-16 grid gap-8 md:grid-cols-2">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white">Founder</h2>
            <p className="text-sm text-slate-300">
              25+ years spanning analog to digital to AI experiences. Principal UX on high-stakes systems across public safety, risk, and compliance.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white">Philosophy</h2>
            <p className="text-sm text-slate-300">
              Design is an ongoing practice. UX lives in code, systems, and operations—not just screens. We partner with developers, data engineers, and domain experts to deliver outcomes.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
